module.exports = __webpack_public_path__ + "img/shipping.14e95df2.svg";